import { AlertWindow } from '@sunwebgroup/uds-ui/alert-window'
import { Button } from '@sunwebgroup/uds-ui/button'
import * as React from 'react'
import { useIntl } from 'react-intl'

export function DeleteAccountSuccessModal() {
  const intl = useIntl()

  const handleClose = () => {
    window.location.replace('/')
  }

  return (
    <AlertWindow.Root open onOpenChange={handleClose}>
      <AlertWindow.Content
        text={intl.formatMessage({ id: 'user_profile_delete_success_title' })}
        renderPrimaryActionSlot={props => (
          <Button {...props} onClick={handleClose}>
            {intl.formatMessage({ id: 'user_profile_delete_success_dismiss' })}
          </Button>
        )}
      />
    </AlertWindow.Root>
  )
}
